<ng-content></ng-content>
<div *ngIf="model && translations" [ngSwitch]="property?.displayAs" class="smart-input-field-container">
  <div *ngSwitchCase="displayEnum.JSON" class="smart-input-field json">
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>{{key}}</mat-panel-title>
        <mat-panel-description>Expand to edit</mat-panel-description>
      </mat-expansion-panel-header>
      <code-area [isString]="property.type === typeEnum.STRING" [key]="key" [parent]="model" [value]="model[key]"
                     type="json"></code-area>
    </mat-expansion-panel>
  </div>

  <div *ngSwitchCase="displayEnum.TEXT" [class.error]="!isValid" class="smart-input-field">
    <mat-form-field>
      <input (change)="change($event)" (keyup)="check()" [(ngModel)]="model[key]" matInput [placeholder]="getFieldTitle()"></mat-form-field>
  </div>

  <div (keyup)="check()" *ngSwitchCase="displayEnum.BOOLEAN" class="smart-input-field toggle">
    <mat-slide-toggle (change)="change($event)" [(ngModel)]="model[key]" color="primary">{{getFieldTitle()}}</mat-slide-toggle>
  </div>

  <div *ngSwitchCase="displayEnum.DROPDOWN" class="smart-input-field dropdown">
    <mat-form-field>
      <mat-select (selectionChange)="change($event); check()" [(ngModel)]="model[key]" [placeholder]="getFieldTitle()">
        <ng-container *ngIf="translationPrefix || fieldConfig; else noTranslation">
          <mat-option *ngFor="let element of dropdownElements" [value]="element">{{getDropdownText(element)}}</mat-option>
        </ng-container>
        <ng-template #noTranslation>
          <mat-option *ngFor="let element of dropdownElements" [value]="element">{{element}}</mat-option>
        </ng-template>
      </mat-select>
    </mat-form-field>
  </div>

  <div *ngSwitchCase="displayEnum.DURATION" class="smart-input-field duration">
    <duration-input [key]="key" [parent]="model" [translationPrefix]="translationPrefix"></duration-input>
  </div>

  <div *ngSwitchCase="displayEnum.COLOR" class="smart-input-field color" (click)="clickColorPicker(key, $event)">
    <input (change)="change($event)" [(ngModel)]="model[key]" type="color" [id]="'colorPicker' + key"/>
    <span>{{getFieldTitle()}}</span>
    <span *ngIf="model[key]" class="value">&nbsp;-&nbsp;{{model[key]}}</span>
  </div>

  <div *ngSwitchCase="displayEnum.TEXTAREA" class="smart-input-field textarea">
    <h3>{{translationKey || key |translate}}</h3>
    <ng-container *ngIf="property.type !== typeEnum.ARRAY">
      <editor [height]="height" (changeContent)="quillChanged($event)" [content]="model[key]"></editor>
    </ng-container>
  </div>

  <div *ngSwitchCase="displayEnum.ARRAY" class="smart-input-field array">
    <span *ngFor="let element of arrayElements, let i = index" class="array-element">
      {{element}}
      <button (click)="removeElement(i)" mat-icon-button><mat-icon>delete</mat-icon></button>
    </span>
    <mat-form-field>
      <input (change)="addElement($event)" matInput [placeholder]="getFieldTitle()"/>
    </mat-form-field>
  </div>

  <div *ngSwitchCase="displayEnum.DATE" class="smart-input-field date">
    <ng-container *ngIf="format==='dd-mm'">
      <day-month-input (onChange)="redirectOnChange($event)" [key]="key" [translationPrefix]="translationPrefix" [value]="model[key]"></day-month-input>
    </ng-container>
    <mat-form-field *ngIf="format!=='dd-mm'" class="minimize-height-sm">
      <input (change)="change($event)" [(ngModel)]="model[key]" [matDatepicker]="datepicker" matInput [placeholder]="getFieldTitle()">
      <mat-datepicker-toggle [for]="datepicker" matPrefix><mat-icon matDatepickerToggleIcon>calendar_month</mat-icon></mat-datepicker-toggle>
      <mat-datepicker #datepicker></mat-datepicker>
    </mat-form-field>
  </div>

  <div *ngSwitchCase="displayEnum.TIME" class="time">
    <mat-form-field class="minimize-height-sm">
      <input [(ngModel)]="model[key]" matInput [placeholder]="getFieldTitle()">
      <button (click)="openTimePicker()" mat-icon-button matPrefix><mat-icon>access_time</mat-icon></button>
    </mat-form-field>
  </div>

  <div *ngSwitchCase="displayEnum.READONLY" class="read-only">{{key}}: {{model[key]}}</div>

  <ng-container *ngSwitchCase="displayEnum.HIDDEN"></ng-container>

  <div *ngSwitchDefault class="smart-input-field">
    Unknown field type: {{displayEnum[property?.displayAs]}}, Coming soon, field data: {{model[key]}}
  </div>

  <ng-container *ngIf="property?.displayAs !== displayEnum.HIDDEN && (property?.description || property?.deprecated || errorMessages.length)">
    <smart-input-hint [additionalClass]="displayEnum[property.displayAs]" [errorMessages]="errorMessages"
                      [hideDescription]="hideDescription" [keyName]="keyName" [property]="property"
                      [translationPrefix]="hintTranslationPrefix"></smart-input-hint>
  </ng-container>

  <button (click)="clearField()" *ngIf="hasTrash && property?.displayAs !== displayEnum.READONLY" class="clearField" mat-icon-button>
    <mat-icon>delete</mat-icon>
  </button>

</div>
